import React from 'react';
import { mountTable, unmountTable, getTable } from '../../views/Components/JQueryTable/JQueryTableLogic.jsx';
import JQueryTableComponent from '../../views/Components/JQueryTable/JQueryTableComponent.jsx';
import { API_ROOT } from '../../variables/api-config';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import ModalRendicion from './ModalRendicion.jsx';
import SweetAlert from "react-bootstrap-sweetalert";

const dataTable = {
  headerRow: ["Nro", "Fecha", "Descripción", "Concepto", "Condicion", "Financia", "Proveedor", "Inventario", "Neto", "Iva", "Total", "Expediente", "Proyecto", "Rendida", "Acciones"],
  footerRow: ["Nro", "Fecha", "Descripción", "Concepto", "Condicion", "Financia", "Proveedor", "Inventario", "Neto", "Iva", "Total", "Expediente", "Proyecto", "Rendida", "Acciones"],
};

class RendicionFondosTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentRendicion: null,
    };
    this.onClickDownloadFile = this.onClickDownloadFile.bind(this);
    this.editAction = this.editAction.bind(this);
    this.deleteAction = this.deleteAction.bind(this);
    this.saveRendicion = this.saveRendicion.bind(this);
    this.exportCsv = this.exportCsv.bind(this);
    this.customAction = [
      {
        htmlString: '<a class="btn btn-simple btn-info btn-icon edit"><i class="fa fa-file text-right"></i></a>',
        actionString: 'click',
        actionFunction: this.onClickDownloadFile,
        disableMe: true,
        columnDisable: 15,
      },
    ];
    this.fixedColWidth = {
      col: 0,
      value: 1,
    }
  }
  componentDidMount() {
    mountTable(API_ROOT + "/administration/rendiciones-grid", "rendicionTab", this.editAction, this.deleteAction, this.customAction, null, null, null, this.fixedColWidth, false, 14);
    // 14 es la posicion del campo 'notificar' para pintar la fila cuando corresponda
  }
  componentWillUnmount() {
    unmountTable('rendicionTab');
  }
  shouldComponentUpdate() {
    return true;
  }
  onClickDownloadFile(data) {
    // JAVASCRIPT TRICKERY!
    const a = document.createElement('a');
    a.href = `${API_ROOT}/administration/rendicion-factura/download/file?id=${data[17]}`;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.parentNode.removeChild(a);
  }
  editAction(data) {
    const rendicion = {
      numerocomprobante: data[0],
      fecha: data[1],
      tipo: {value: data[19], label: data[2]},
      concepto: data[3],
      condicion: {value: data[4], label: data[4]},
      financia: {value: data[5], label: data[5]},
      proveedor: {value: data[6], label: data[6]},
      inventario: {value: data[7], label: data[7]},
      neto: data[8],
      iva: data[9],
      total: data[10],
      expediente: data[11],
      proyectoid: data[12] ? {value: data[18], label: data[12]} : '',
      rendida: data[13],
      responsable: {value: data[15], label: data[15]},
      nombrearchivo: data[16],
      fasociada: data[20],
      id: data[17],
    };
    this.setState({currentRendicion: rendicion, modalOpen: true});
  }
  deleteAction(data) {
    this.props.showAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Eliminar?"
          onConfirm={() => this.confirmDelete(data[17])}
          onCancel={() => this.props.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Sí!"
          cancelBtnText="Cancelar"
          showCancel
        >
          {`Desea ELIMINAR el comprobante?`}
          <p>Esta acción no se puede deshacer</p>
        </SweetAlert>
      );
  }
  confirmDelete(id) {
    const table = getTable('rendicionTab');
    this.props.administrationService.deleteFacturaFondos(id)
    .then(res => {
      table.clear();
      table.ajax.reload();
      table.draw();
      this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Factura borrada!</div>), 10);
      this.props.hideAlert();
    })
    .catch(err => {
      this.props.errorAlert(
        <div>
          Ocurrio un error mientras se guardaban los datos, el servidor ha
          devuelto la siguiente información: <p>{err.message}</p>
        </div>);
    });
  }

  saveRendicion(rendicion) {
    const table = getTable('rendicionTab');
    this.props.administrationService.postRendicion(rendicion)
    .then(res => {
      this.setState({modalOpen: false, currentRendicion: null});
      table.clear();
      table.ajax.reload();
      table.draw();
      this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Rendición Guardada!</div>), 10);
    })
    .catch(err => {
      this.props.errorAlert(
        <div>
          Ocurrio un error mientras se guardaban los datos, el servidor ha
          devuelto la siguiente información: <p>{err.message}</p>
        </div>);
    });
  }

  exportCsv() {
    const table = getTable('rendicionTab');
    const data = table.ajax.params().params;
    const objectParams = {
      search: data.search.value,
      start: data.start,
      length: data.length,
      column: data.order[0].column,
      dir: data.order[0].dir,
      draw: data.draw,
    };
    const queryString = Object.keys(objectParams).map((key) => {
      return key + '=' + objectParams[key];
    }).join('&');

    // JAVASCRIPT TRICKERY!
    const a = document.createElement('a');
    a.href = `${API_ROOT}/administration/rendicion-factura/export/csv?${queryString}`;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.parentNode.removeChild(a);
  }

  render() {
    return(
      <div>
        <div style={{ paddingBottom: 10 + "px", textAlign: "right" }} className="visible-xs-block">
          <Button bsStyle="primary" bsSize="sm" fill wd block onClick={() => this.setState({modalOpen: true})}>
            Cargar nuevo comprobante
          </Button>
        </div>
        <div style={{ textAlign: "right", paddingBottom: 5 }} className="hidden-xs">
          <Button bsStyle="primary" bsSize="sm" fill wd onClick={() => this.setState({modalOpen: true})}>
            Cargar nuevo comprobante
          </Button>
        </div>
        <div className="fresh-datatables" style={{maxWidth: '100%', overflowX: 'auto'}}>
          <JQueryTableComponent dataTable={dataTable} identifier="rendicionTab" />
        </div>
        <div style={{ paddingTop: 10 + "px", textAlign: "right" }} className="visible-xs-block">
          <Button bsStyle="primary" bsSize="sm" fill wd block onClick={this.exportCsv}>
            Exportar<i className="fa fa-download"></i>
          </Button>
        </div>
        <div style={{ textAlign: "right", paddingBottom: 5 }} className="hidden-xs">
          <Button bsStyle="primary" bsSize="sm" fill wd onClick={this.exportCsv}>
            Exportar<i className="fa fa-download"></i>
          </Button>
        </div>
        {this.state.modalOpen &&
          <ModalRendicion
            tiposComprobantes={this.props.tiposComprobantes}
            closeModal={() => this.setState({modalOpen: false, currentRendicion: null})}
            hideAlert={this.props.hideAlert} errorAlert={this.props.errorAlert}
            rendicion={this.state.currentRendicion} saveRendicion={this.saveRendicion}
          />
        }
      </div>
    );
  }
}

export default RendicionFondosTab;



// WEBPACK FOOTER //
// ./src/views/Administration/RendicionFondosTab.jsx